export default ($sceDelegateProvider) => {
    const { ASSETS_URL } = SEED_CORE.ENV;
    $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        `${ASSETS_URL}**`
    ]);
};



// WEBPACK FOOTER //
// ./src/app/configs/$sce/index.js